export default {
    data: function () {
        return this.loadValues({
            variations: [],
            address_line_1: '',
            address_line_2: '',
            address_town: '',
            address_postcode: '',
            address_latitude: '',
            address_longitude: '',
            address_full: '',
        });
    },
    mounted() {
        const fields = [
            { element: "address_search", field: "AddressSearch" },

            { element: "address_line_1", field: "Line1", mode: pca.fieldMode.POPULATE },
            { element: "address_line_2", field: "Line2", mode: pca.fieldMode.POPULATE },
            { element: "address_town", field: "City", mode: pca.fieldMode.POPULATE },

            { element: "address_postcode", field: "PostalCode", mode: pca.fieldMode.POPULATE },
        ];

        const loqateKey = document.querySelector('meta[name="loqate-key"]').getAttribute('content');
        const options = {
            key: loqateKey, search: { countries: "GBR" }, setCountryByIP: true,
            advancedFields: [
                '{Latitude}',
                '{Longitude}'
            ]
        };
        const control = new pca.Address(fields, options);

        // When Loqate populates the field, update the full address field. 
        control.listen("populate", (address) => {
            this.updateAddress(address);
        });
    },
    methods: {
        updateAddress({ Line1, Line2, City, Province, PostalCode, Field1: Latitude, Field2: Longitude }) {
            const fullAddress = [Line1, Line2, City, Province, PostalCode].filter(Boolean).join(', ');

            this.address_full = fullAddress;

            this.address_line_1 = Line1;
            this.address_line_2 = Line2;
            this.address_town = City;
            this.address_postcode = PostalCode;
            this.address_latitude = Latitude;
            this.address_longitude = Longitude;
        },
        syncFullAddress() {
            this.address_full = [
                this.address_line_1,
                this.address_line_2,
                this.address_town,
                this.address_postcode
            ].filter(Boolean).join(', ');

            // If the user manually updates their address, clear the lat/long as their address may not be true to the previous geocode
            this.address_latitude = '';
            this.address_longitude = '';
        }
    }
};
